





































import Vue from 'vue';
import User from '@glittr/frontend-core/src/plugins/auth/user';
import OnlinePaymentResourceViewModel from '@/src/services/viewModel/resource/OnlinePaymentResourceViewModel';
import MemberDataResourceViewModel from '@/src/services/viewModel/resource/MemberDataResourceViewModel';
import ContactAddressResourceViewModel from '@/src/services/viewModel/resource/ContactAddressResourceViewModel';

export default Vue.extend({
  auth: true,
  props: {
    value: { type: Object, default: undefined },
    proceedFunction: { type: Function, default: () => {} },
  },
  data: () => ({
    isLoading: false,
    membership: new MemberDataResourceViewModel(),
    user: new User(),
  }),
  computed: {
    customFields(): Record<string, any> {
      return {
        stored_customer_number: this.membership?.memberContact?.customerNumber,
      };
    },
    memberAddress(): ContactAddressResourceViewModel {
      return this.membership?.memberContact?.address;
    },
    invoiceId(): string {
      return this.$router.currentRoute.params.id;
    },
    innerValue: {
      get(): OnlinePaymentResourceViewModel {
        return this.value ?? {};
      },
      set(value: OnlinePaymentResourceViewModel) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.populateData();
  },
  methods: {
    async populateData() {
      this.isLoading = true;
      const response = await this.$service.api.memberships.getMyMembership();
      this.membership = response ?? new MemberDataResourceViewModel();
      this.user = (await this.$auth.getUser())!;
      const email = this.membership.memberContact.address.eMail ?? this.user.email;
      this.memberAddress.dateOfBirth = this.$format.date(this.memberAddress.dateOfBirth!, 'YYYY-MM-DD');
      this.memberAddress.eMail = email;
      this.isLoading = false;
    },
    onPayed(data: OnlinePaymentResourceViewModel) {
      this.isLoading = true;
      this.proceedFunction!();
    },
  },

});
